<template>
  <b-overlay :show="true" id="upgrade-overlay" variant="white" blur="5px" rounded="sm">
    <template #overlay>
      <b-card class="shadow-xl" id="upgrade">
        <b-row class="mt-3">
          <b-col>
            <img :src="'/img/' + upgradeImg" id="modal-img" />
          </b-col>
          <b-col>
            <h2>Expand Your Features</h2>
            <p>The current plan that you have selected does not include this feature. You can upgrade today to receive even more insight into your business.</p>
            <b-button block variant="danger" :to="'/subscriptions'" class="mt-3">Upgrade Now <i class="fas fa-angle-double-up"></i></b-button>
          </b-col>
        </b-row>
      </b-card>
    </template>
    <b-card no-body>
      <b-card-header>
        <h3 class="mb-0">{{ title }}</h3>
      </b-card-header>
      <img :src="'/img/' + placeholderImg" id="placeholder-img" />
    </b-card>
  </b-overlay>
</template>

<script>
export default {
  props: {
    title: null,
    placeholderImg: null,
    upgradeImg: null
  }
};
</script>
<style lang="scss">
#modal-img {
  width: 100%;
}
#upgrade .card-body {
  background: linear-gradient(to right, #dc3545, white 50%);
}
</style>